var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnChanges, EventEmitter, SimpleChanges, TemplateRef, Renderer2, OnDestroy, } from "@angular/core";
import { CampaignsService, JobOffersService, EventsService, PollsService, CandidatesService, PagerService, CommonService, SessionService, ClevertapEventsService, } from "../../services";
import { ActivatedRoute, Router } from "@angular/router";
import * as moment from "moment";
import { WebinarsService } from "app/services/webinars.service";
import { DigitalCareerDaysService } from "app/services/digital-career-days.service";
import { BsModalService } from "ngx-bootstrap";
import { LocalStorageHelpers } from "app/helpers";
import { FeatureFlagService } from "app/services/feature-flag.service";
import { AppService } from "app/services/app.service";
import { environment } from "environments/environment";
var AppPagedTableComponent = /** @class */ (function () {
    function AppPagedTableComponent(jobOfferService, eventsService, pollService, campaignService, candidatesService, pagerService, commonService, sessionService, webinarsService, careerDayService, router, route, localStorageHelper, modalService, renderer, ffs, appService) {
        var _this = this;
        this.jobOfferService = jobOfferService;
        this.eventsService = eventsService;
        this.pollService = pollService;
        this.campaignService = campaignService;
        this.candidatesService = candidatesService;
        this.pagerService = pagerService;
        this.commonService = commonService;
        this.sessionService = sessionService;
        this.webinarsService = webinarsService;
        this.careerDayService = careerDayService;
        this.router = router;
        this.route = route;
        this.localStorageHelper = localStorageHelper;
        this.modalService = modalService;
        this.renderer = renderer;
        this.ffs = ffs;
        this.appService = appService;
        this.items = null;
        this.destinationUrl = null;
        this.notify = new EventEmitter();
        this.onCopy = new EventEmitter();
        this.data = [];
        this.numberPage = [];
        this.currentPage = 1;
        this.limitPage = 10;
        this.allItems = [];
        this.loading = false;
        this.noResults = false;
        this.noResultsLabel = "No results";
        this.selectedCandidate = null;
        this.jboxEnabled = this.ffs.isEnabled("pbox") || false;
        this.pager = {};
        this.openedFromUrlQP = false;
        this.previousId = null;
        this.nextId = null;
        this.employersId = null;
        // this.scrollTop();
        try {
            var tmp = JSON.parse(this.localStorageHelper.get("userData"));
            this.employersId = tmp.Teams[0]["employers_id"];
        }
        catch (e) {
            this.employersId = null;
        }
        this.msoh = this.modalService.onHide.subscribe(function () {
            // console.log('this.modalService.onHide.subscribe');
            _this.setup(_this.currentPage);
            window.scrollTo(0, _this.scrollY);
            _this.renderer.removeClass(document.body, "no-scroll");
            // FIX-ME
            _this.updateUrlQueryParams();
            _this.openedFromUrlQP = false;
        });
        this.msos = this.modalService.onShown.subscribe(function () {
            // console.log('this.modalService.onShown.subscribe');
            window.scrollTo(0, _this.scrollY);
            _this.renderer.addClass(document.body, "no-scroll");
        });
        this.ffs.unleash.on("update", function () {
            if (_this.ffs.isEnabled('pbox') !== _this.jboxEnabled) {
                _this.jboxEnabled = _this.ffs.isEnabled('pbox');
            }
        });
    }
    Object.defineProperty(AppPagedTableComponent.prototype, "currPage", {
        get: function () {
            return this.currentPage - 1;
        },
        enumerable: true,
        configurable: true
    });
    AppPagedTableComponent.prototype.openDetail = function (data) {
        this.selectedCandidate = data;
    };
    AppPagedTableComponent.prototype.forwardToPBox = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var popup, tokenResp, jboxUrl, finalUrl, finalUrlV2, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!id) {
                            return [2 /*return*/];
                        }
                        popup = window.open("", "_blank");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.appService.createJBoxTokenV2(id).toPromise()];
                    case 2:
                        tokenResp = _a.sent();
                        console.log("token", tokenResp);
                        jboxUrl = environment.jboxUrl;
                        if (window.location.hostname === "localhost") {
                            jboxUrl = "http://localhost:3003";
                        }
                        console.log("environment.jboxUrl", jboxUrl);
                        finalUrl = jboxUrl + "/auth/" + tokenResp.token;
                        console.log("finalUrl", finalUrl);
                        finalUrlV2 = jboxUrl + "/magic-link/job-postings/" + tokenResp.token;
                        console.log("finalUrlV2", finalUrlV2);
                        if (popup) {
                            popup.location.href = finalUrlV2;
                            popup.focus();
                        }
                        else {
                            // Fallback: try to open the URL directly (may still be blocked)
                            window.open(finalUrlV2, "_blank");
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        // If there was an error, close the popup if it was opened.
                        if (popup) {
                            popup.close();
                        }
                        console.error("Unable to redirect to PBox:", err_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AppPagedTableComponent.prototype.ngOnChanges = function (event) {
        // console.log('changed', event);
        if (!event.filters || !event.filters.firstChange) {
            this.loading = true;
            this.noResults = false;
            this.pager = {};
            this.pagedItems = [];
            this.currentPage = 1;
            var storedPage = this.sessionService.get(this.type + "_paging");
            if (storedPage) {
                this.currentPage = storedPage;
            }
            this.setupByType();
        }
        console.log(event.items);
    };
    AppPagedTableComponent.prototype.setupByType = function () {
        var _this = this;
        var stored;
        switch (this.type) {
            case "webinars": {
                this.setup = this.setupWebinars;
                this.setupWebinars(this.currentPage);
                break;
            }
            case "digital-career-days": {
                this.setup = this.setupDigitalCareerDays;
                this.setupDigitalCareerDays(this.currentPage);
                break;
            }
            case "joboffers":
                this.setup = this.setupJobOffers;
                this.setupJobOffers(this.currentPage);
                break;
            case "events":
                this.setup = this.setupEvents;
                this.setupEvents(this.currentPage);
                break;
            case "polls":
                this.setup = this.setupPolls;
                stored = this.sessionService.get("polls");
                if (stored) {
                    this.setupPolls(stored);
                }
                this.campaignService.getAllPolls().subscribe(function (polls) {
                    _this.sessionService.set("polls", polls);
                    _this.setupPolls(polls);
                });
                break;
            case "articles":
                this.setup = this.setupArticles;
                stored = this.sessionService.get("articles");
                if (stored) {
                    this.setupArticles(stored);
                }
                this.campaignService.getAllArticles().subscribe(function (articles) {
                    _this.sessionService.set("articles", articles);
                    _this.setupArticles(articles);
                });
                break;
            case "candidates":
                this.currentPage = 1;
                this.setup = this.setupTalentPool;
                this.noResultsLabel =
                    "You don't have any candidates yet or you are not collecting cv, " +
                        "post a job without external link to create your own database of cv";
                this.setupTalentPool(this.currentPage);
                break;
            case "curricula-joboffer":
                this.currentPage = 1;
                this.setup = this.setupCandidates;
                this.noResultsLabel =
                    "You don't have any candidates yet or you are not collecting cv, " +
                        "post a job without external link to create your own database of cv";
                this.setupCandidates(this.currentPage);
                break;
        }
    };
    AppPagedTableComponent.prototype.setupPolls = function (polls) {
        // console.log('polls', polls);
        for (var i = 0; i < polls.length; i++) {
            var formattedPoll = {
                answer1: "",
                answer2: "",
                total1: 0,
                total2: 0,
                total: 0,
            };
            var post = polls[i]["Post"];
            if (post) {
                // console.log('post', post);
                formattedPoll.answer1 = post["Answers"][0]
                    ? post["Answers"][0]["answer"]
                    : "";
                formattedPoll.answer2 = post["Answers"][1]
                    ? post["Answers"][1]["answer"]
                    : "";
                for (var j = 0; j < post["UserAnswers"].length; j++) {
                    if (post["UserAnswers"][j]["answers_id"] === post["Answers"][0].id) {
                        formattedPoll.total1++;
                    }
                    if (post["UserAnswers"][j]["answers_id"] === post["Answers"][1].id) {
                        formattedPoll.total2++;
                    }
                }
                formattedPoll["total"] = formattedPoll.total1 + formattedPoll.total2;
                formattedPoll["percentage1"] = Math.round((formattedPoll.total1 / formattedPoll.total) * 100);
                formattedPoll["percentage2"] = Math.round((formattedPoll.total2 / formattedPoll.total) * 100);
            }
            // delete polls[i]['Post'];
            polls[i]["Post"]["Answers"] = formattedPoll;
        }
        this.allItems = polls;
        console.log("this.allItems", this.allItems);
        var stored_page = this.sessionService.get(this.type + "_paging");
        if (stored_page) {
            this.setupTableElement(stored_page);
            this.setPage(stored_page);
        }
        else {
            this.setupTableElement(1);
            this.setPage(1);
        }
    };
    AppPagedTableComponent.prototype.setupArticles = function (articles) {
        this.allItems = articles;
        var stored_page = this.sessionService.get(this.type + "_paging");
        if (stored_page) {
            this.setupTableElement(stored_page);
            this.setPage(stored_page);
        }
        else {
            this.setupTableElement(1);
            this.setPage(1);
        }
    };
    AppPagedTableComponent.prototype.setupCandidates = function (page) {
        return __awaiter(this, void 0, void 0, function () {
            var sanitizedFilters, candidates;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        console.log(this.filters);
                        sanitizedFilters = JSON.parse(JSON.stringify(this.filters));
                        if (sanitizedFilters["job_offers_id"]) {
                            sanitizedFilters["job_offers_id"] =
                                sanitizedFilters["job_offers_id"].value;
                        }
                        if (sanitizedFilters["languages_id"]) {
                            sanitizedFilters["languages_id"] = Number(sanitizedFilters["languages_id"].value);
                        }
                        if (sanitizedFilters["language_level"]) {
                            sanitizedFilters["language_level"] = Number(sanitizedFilters["language_level"].value);
                        }
                        if (sanitizedFilters["cities_ids"] && sanitizedFilters["cities_ids"][0]) {
                            sanitizedFilters["cities_ids"][0] = sanitizedFilters["cities_ids"][0].id;
                        }
                        if (sanitizedFilters["universities_ids"] &&
                            sanitizedFilters["universities_ids"][0]) {
                            sanitizedFilters["universities_ids"][0] =
                                sanitizedFilters["universities_ids"][0].id;
                        }
                        if (sanitizedFilters["faculty_tags"] &&
                            sanitizedFilters["faculty_tags"][0]) {
                            sanitizedFilters["faculty_tags"][0] =
                                sanitizedFilters["faculty_tags"][0].id;
                        }
                        if (sanitizedFilters["tags_ids"] && sanitizedFilters["tags_ids"][0]) {
                            sanitizedFilters["tags_ids"][0] = sanitizedFilters["tags_ids"][0].id;
                        }
                        else {
                            delete sanitizedFilters["tags_ids"];
                        }
                        if (sanitizedFilters["skills_ids"] && sanitizedFilters["skills_ids"][0]) {
                            sanitizedFilters["skills_ids"][0] = sanitizedFilters["skills_ids"][0].id;
                        }
                        console.log(sanitizedFilters);
                        return [4 /*yield*/, this.candidatesService
                                .getAll(sanitizedFilters, page - 1)
                                .toPromise()];
                    case 1:
                        candidates = _a.sent();
                        // console.log('candidates', candidates);
                        this.notify.emit(candidates);
                        this.total = candidates["total"];
                        this.pagedItems = candidates["rows"];
                        this.totalPages = Math.ceil(this.total / 20);
                        this.asyncSetupTableElement(page);
                        this.asyncSetPage(page);
                        return [2 /*return*/];
                }
            });
        });
    };
    AppPagedTableComponent.prototype.setupTalentPool = function (page) {
        return __awaiter(this, void 0, void 0, function () {
            var sanitizedFilters, candidates;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        console.log(this.filters);
                        sanitizedFilters = JSON.parse(JSON.stringify(this.filters));
                        if (sanitizedFilters["job_offers_id"]) {
                            sanitizedFilters["job_offers_id"] =
                                sanitizedFilters["job_offers_id"].value;
                        }
                        if (sanitizedFilters["languages_id"]) {
                            sanitizedFilters["languages_id"] = Number(sanitizedFilters["languages_id"].value);
                        }
                        if (sanitizedFilters["language_level"]) {
                            sanitizedFilters["language_level"] = Number(sanitizedFilters["language_level"].value);
                        }
                        if (sanitizedFilters["cities_ids"] && sanitizedFilters["cities_ids"][0]) {
                            sanitizedFilters["cities_ids"][0] = sanitizedFilters["cities_ids"][0].id;
                        }
                        if (sanitizedFilters["institutes_ids"] &&
                            sanitizedFilters["institutes_ids"][0]) {
                            sanitizedFilters["institutes_ids"][0] =
                                sanitizedFilters["institutes_ids"][0].id;
                        }
                        if (sanitizedFilters["faculty_tags"] &&
                            sanitizedFilters["faculty_tags"][0]) {
                            sanitizedFilters["faculty_tags"][0] =
                                sanitizedFilters["faculty_tags"][0].id;
                        }
                        if (sanitizedFilters["tags_ids"] && sanitizedFilters["tags_ids"][0]) {
                            // sanitizedFilters["tags_ids"][0] = sanitizedFilters["tags_ids"][0].id;
                            sanitizedFilters["tags"] = [sanitizedFilters["tags_ids"][0].name];
                            delete sanitizedFilters["tags_ids"];
                        }
                        else {
                            delete sanitizedFilters["tags_ids"];
                        }
                        if (sanitizedFilters["skills_ids"] && sanitizedFilters["skills_ids"][0]) {
                            sanitizedFilters["skills_ids"][0] = sanitizedFilters["skills_ids"][0].id;
                        }
                        if (sanitizedFilters["study_tags_ids"] && sanitizedFilters["study_tags_ids"][0]) {
                            sanitizedFilters["study_tags_ids"][0] = sanitizedFilters["study_tags_ids"][0].id;
                        }
                        if (sanitizedFilters["geolocations_ids"] && sanitizedFilters["geolocations_ids"][0]) {
                            sanitizedFilters["geolocations_ids"][0] = String(sanitizedFilters["geolocations_ids"][0].id);
                        }
                        if (sanitizedFilters['user_status'] && sanitizedFilters['user_status'] !== 'all') {
                            sanitizedFilters['user_status'] = [sanitizedFilters['user_status']];
                        }
                        else {
                            delete sanitizedFilters['user_status'];
                        }
                        delete sanitizedFilters['status'];
                        console.log(sanitizedFilters);
                        return [4 /*yield*/, this.candidatesService
                                .getTalentPool(sanitizedFilters, page - 1, 20)
                                .toPromise()];
                    case 1:
                        candidates = _a.sent();
                        // console.log('candidates', candidates);
                        this.notify.emit(candidates);
                        this.total = candidates["total"];
                        this.pagedItems = candidates["list"];
                        this.pagedItems.forEach(function (c) { return c.other_applications = c.other_applications.reverse(); });
                        this.totalPages = Math.ceil(this.total / 20);
                        this.selectedCandidate = this.pagedItems[0];
                        this.asyncSetupTableElement(page);
                        this.asyncSetPage(page, 20);
                        return [2 /*return*/];
                }
            });
        });
    };
    AppPagedTableComponent.prototype.setupWebinars = function (page) {
        var _this = this;
        this.loading = true;
        // FIX-ME
        // change below service
        if (this.items && this.items !== null) {
            if (this.items.length === 0) {
                this.noResultsLabel = "Currently there are no active experiences";
            }
            this.notify.emit(this.items);
            // FIX-ME need to check with Simone
            this.total = this.items.length;
            this.pagedItems = this.items;
            this.asyncSetupTableElement(page);
            this.asyncSetPage(page);
        }
        else {
            this.webinarsService.getAll(page - 1).subscribe(function (webinars) {
                if (webinars.count === 0) {
                    _this.noResultsLabel = "Currently there are no active experiences";
                }
                _this.notify.emit(webinars);
                // FIX-ME need to check with Simone
                _this.total = webinars.count;
                _this.pagedItems = webinars.rows;
                _this.asyncSetupTableElement(page);
                _this.asyncSetPage(page);
            });
        }
    };
    AppPagedTableComponent.prototype.setupDigitalCareerDays = function (page) {
        var _this = this;
        this.loading = true;
        // FIX-ME
        // change below service
        this.careerDayService.getAll(page - 1).subscribe(function (result) {
            if (result.length === 0) {
                // this.noResultsLabel = 'Currently there are no active webinar';
            }
            // FIX-ME check code below before uncomment
            // let _new;
            // for (let i = jobOffers['rows'].length - 1; i >= 0; i--) {
            //   _new = 0;
            //   if (jobOffers['rows'][i]['UserJobs'] && jobOffers['rows'][i]['UserJobs'].length) {
            //     for (let k = jobOffers['rows'][i]['UserJobs'].length - 1; k >= 0; k--) {
            //       if (!jobOffers['rows'][i]['UserJobs'][k]['viewed']) {
            //         _new++;
            //       }
            //     }
            //     jobOffers['rows'][i]['new_applications'] = _new;
            //   }
            // }
            _this.notify.emit(result);
            // FIX-ME need to check with Simone
            _this.total = result.length;
            _this.pagedItems = result;
            _this.asyncSetupTableElement(page);
            _this.asyncSetPage(page);
        });
    };
    AppPagedTableComponent.prototype.setupJobOffers = function (page) {
        var _this = this;
        this.loading = true;
        if (this.items && this.items !== null) {
            if (this.items.length === 0) {
                this.noResultsLabel = "Currently there are no active job offers";
            }
            var _new = void 0;
            for (var i = this.items.length - 1; i >= 0; i--) {
                _new = 0;
                if (this.items[i]["UserJobs"] && this.items[i]["UserJobs"].length > 0) {
                    for (var k = this.items[i]["UserJobs"].length - 1; k >= 0; k--) {
                        if (!this.items[i]["UserJobs"][k]["viewed"]) {
                            _new++;
                        }
                    }
                    this.items[i]["new_applications"] = _new;
                }
            }
            this.notify.emit(this.items);
            this.total = this.items.length;
            this.pagedItems = this.items;
            this.asyncSetupTableElement(page);
            this.asyncSetPage(page);
        }
        else {
            var obs = this.jobOfferService.getJobsV3(page - 1);
            obs.subscribe(function (jobOffers) {
                if (jobOffers["count"] === 0) {
                    _this.noResultsLabel = "Currently there are no active job offers";
                }
                var _new;
                for (var i = jobOffers["rows"].length - 1; i >= 0; i--) {
                    _new = 0;
                    if (jobOffers["rows"][i]["UserJobs"] &&
                        jobOffers["rows"][i]["UserJobs"].length) {
                        for (var k = jobOffers["rows"][i]["UserJobs"].length - 1; k >= 0; k--) {
                            if (!jobOffers["rows"][i]["UserJobs"][k]["viewed"]) {
                                _new++;
                            }
                        }
                        jobOffers["rows"][i]["new_applications"] = _new;
                    }
                }
                _this.notify.emit(jobOffers);
                _this.total = jobOffers["count"];
                _this.pagedItems = jobOffers["rows"];
                _this.asyncSetupTableElement(page);
                _this.asyncSetPage(page);
            });
        }
    };
    AppPagedTableComponent.prototype.setupEvents = function (page) {
        var _this = this;
        this.loading = true;
        this.eventsService.getAll(page - 1).subscribe(function (events) {
            if (events["total"] === 0) {
                _this.noResultsLabel = "Currently there are no active events";
            }
            var _new;
            for (var i = events["rows"].length - 1; i >= 0; i--) {
                _new = 0;
                if (events["rows"][i]["UserJobs"] &&
                    events["rows"][i]["UserJobs"].length) {
                    for (var k = events["rows"][i]["UserJobs"].length - 1; k >= 0; k--) {
                        if (!events["rows"][i]["UserJobs"][k]["viewed"]) {
                            _new++;
                        }
                    }
                    events["rows"][i]["new_applications"] = _new;
                }
            }
            _this.notify.emit(events);
            _this.total = events["total"];
            _this.pagedItems = events["rows"];
            _this.asyncSetupTableElement(page);
            _this.asyncSetPage(page);
        });
    };
    AppPagedTableComponent.prototype.setPage = function (page) {
        this.loading = false;
        this.noResults = this.allItems.length === 0;
        if (page < 1 || page > this.pager.totalPages) {
            return;
        }
        // Store paging to session
        this.sessionService.set(this.type + "_paging", page);
        // get pager object from service
        this.pager = this.pagerService.getPager(this.allItems.length, page);
        // get current page of items
        this.pagedItems = this.allItems.slice(this.pager.startIndex, this.pager.endIndex + 1);
    };
    AppPagedTableComponent.prototype.asyncSetPage = function (page, limit) {
        if (limit === void 0) { limit = 10; }
        this.loading = false;
        this.noResults = this.total === 0;
        if (page < 1 || page > this.pager.totalPages) {
            return;
        }
        this.sessionService.set(this.type + "_paging", page);
        this.pager = this.pagerService.getPager(this.total, page, limit);
    };
    AppPagedTableComponent.prototype.asyncSetupTableElement = function (page) {
        var _this = this;
        this.currentPage = page;
        var start = (page - 1) * this.limitPage;
        var stop = page * this.limitPage;
        this.data = [];
        this.pagedItems.forEach(function (value, index) {
            if (index >= start && index < stop) {
                _this.data.push(value);
            }
        });
    };
    AppPagedTableComponent.prototype.setupTableElement = function (page) {
        var _this = this;
        // console.log('page', page);
        this.currentPage = page;
        var start = (page - 1) * this.limitPage;
        var stop = page * this.limitPage;
        this.data = [];
        this.allItems.forEach(function (value, index) {
            if (index >= start && index < stop) {
                _this.data.push(value);
            }
        });
    };
    AppPagedTableComponent.prototype.isFinished = function (date) {
        return moment().diff(date) > 0;
    };
    AppPagedTableComponent.prototype.updateUrlQueryParams = function (value, key) {
        if (value === void 0) { value = null; }
        if (key === void 0) { key = "cvId"; }
        var _a;
        return;
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: (_a = {}, _a[key] = value, _a),
            queryParamsHandling: "merge",
        });
    };
    AppPagedTableComponent.prototype.goToPrevious = function (id) {
        // this.openModal(null, null, id, null, this.curricula.filter(c => c['User']['id'] === id)[0]);
        this.curriculaId = id;
        ClevertapEventsService.emitEvent("openedCv", {
            employers_id: this.employersId,
        });
        // this.previousId = this.curricula[index - 1] ? this.curricula[index - 1]['User']['id'] : null;
        // this.nextId = this.curricula[index + 1] ? this.curricula[index + 1]['User']['id'] : null;
        var current = this.pagedItems.filter(function (c) { return c["User"]["id"] === id; })[0];
        this.curriculum = current;
        var currentPosition = this.pagedItems.indexOf(current);
        this.previousId = this.pagedItems[currentPosition - 1]
            ? this.pagedItems[currentPosition - 1]["User"]["id"]
            : null;
        this.nextId = this.pagedItems[currentPosition + 1]
            ? this.pagedItems[currentPosition + 1]["User"]["id"]
            : null;
        this.updateUrlQueryParams(this.curriculaId);
    };
    AppPagedTableComponent.prototype.goToNext = function (id) {
        // this.openModal(null, null, id, null, this.curricula.filter(c => c['User']['id'] === id)[0]);
        this.curriculaId = id;
        ClevertapEventsService.emitEvent("openedCv", {
            employers_id: this.employersId,
        });
        var current = this.pagedItems.filter(function (c) { return c["User"]["id"] === id; })[0];
        this.curriculum = current;
        var currentPosition = this.pagedItems.indexOf(current);
        this.previousId = this.pagedItems[currentPosition - 1]
            ? this.pagedItems[currentPosition - 1]["User"]["id"]
            : null;
        this.nextId = this.pagedItems[currentPosition + 1]
            ? this.pagedItems[currentPosition + 1]["User"]["id"]
            : null;
        this.updateUrlQueryParams(this.curriculaId);
    };
    AppPagedTableComponent.prototype.goToPreviousPage = function ($event) {
        var _this = this;
        this.setupCandidates($event).then(function () {
            var index = _this.pagedItems.length - 1;
            _this.curriculaId = _this.pagedItems[index]["User"]["id"];
            _this.curriculum = _this.pagedItems[index];
            ClevertapEventsService.emitEvent("openedCv", {
                employers_id: _this.employersId,
            });
            _this.previousId = _this.pagedItems[index - 1]
                ? _this.pagedItems[index - 1]["User"]["id"]
                : null;
            _this.nextId = index;
            _this.updateUrlQueryParams(_this.curriculaId);
        });
    };
    AppPagedTableComponent.prototype.goToNextPage = function ($event) {
        var _this = this;
        this.setupCandidates($event).then(function () {
            var index = 0;
            _this.curriculaId = _this.pagedItems[index]["User"]["id"];
            _this.curriculum = _this.pagedItems[index];
            ClevertapEventsService.emitEvent("openedCv", {
                employers_id: _this.employersId,
            });
            _this.previousId = null;
            _this.nextId = _this.pagedItems[index + 1]
                ? _this.pagedItems[index + 1]["User"]["id"]
                : null;
            _this.updateUrlQueryParams(_this.curriculaId);
        });
    };
    AppPagedTableComponent.prototype.openModal = function ($event, _template, userId, jobId, curriculum, index) {
        this.scrollY = window.scrollY;
        if ($event && $event.target) {
            $event.preventDefault();
            $event.stopImmediatePropagation();
            $event.stopPropagation();
        }
        // this.curricula.forEach(c => c['toggled'] = false);
        // if (curriculum && curriculum['toggled']) {
        //   curriculum['toggled'] = !curriculum['toggled']
        // } else {
        //   curriculum['toggled'] = true;
        // }
        // if (this.external) {
        //   return;
        // }
        this.modalRef = this.modalService.show(_template, {
            class: "modal-big",
            animated: false,
        });
        this.curriculaId = userId;
        ClevertapEventsService.emitEvent("openedCv", {
            employers_id: this.employersId,
        });
        if (index !== null) {
            this.previousId = this.pagedItems[index - 1]
                ? this.pagedItems[index - 1]["User"]["id"]
                : null;
            this.nextId = this.pagedItems[index + 1]
                ? this.pagedItems[index + 1]["User"]["id"]
                : null;
        }
        this.updateUrlQueryParams(this.curriculaId);
        // tslint:disable-next-line
        // const e = document.getElementsByClassName('accordion-' + userId)[0] as any;
        // e.focus();
        // setTimeout(() => {
        //   window.scrollTo(0, this.scrollY)
        // }, 250);
    };
    AppPagedTableComponent.prototype.ngOnDestroy = function () {
        if (this.msoh) {
            this.msoh.unsubscribe();
        }
        if (this.msos) {
            this.msos.unsubscribe();
        }
    };
    AppPagedTableComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        // FIX-ME
        // if cvId is present in url qp
        if (this.route.snapshot.queryParams.cvId) {
            setTimeout(function () {
                _this.openedFromUrlQP = true;
                _this.openModal(null, _this.templateRef, _this.route.snapshot.queryParams.cvId, null, null, null);
            });
        }
    };
    AppPagedTableComponent.prototype.view = function (id, index) {
        var url = "";
        switch (this.type) {
            case "digital-career-days": {
                url = "/career_days/";
                break;
            }
            case "webinars": {
                url = "/experiences/";
                break;
            }
            case "joboffers":
                url = "/recruiting/";
                break;
            case "events":
                url = "/events/";
                break;
            case "articles":
                url = "/articles/";
                break;
            case "polls":
                url = "/polls/";
                break;
            case "candidates":
                url = "/recruiting/curricula/";
                break;
        }
        if (index) {
            this.pagedItems[index].viewed = true;
        }
        if (this.destinationUrl) {
            url = this.destinationUrl;
        }
        if (this.type === "candidates") {
            this.openModal(id, this.templateRef, id, null, this.curriculum, index);
        }
        else {
            this.router.navigate([url, id]);
        }
    };
    // (id dell'utente)
    AppPagedTableComponent.prototype.setViewed = function (users_id) {
        this.commonService.setEmployersUsersViewed(users_id).subscribe(function (res) {
            console.log("Set viewed", res);
        });
    };
    AppPagedTableComponent.prototype.isNew = function (candidate) {
        for (var i in candidate.JobOffers) {
            if (candidate.JobOffers[i].UserJob.viewed) {
                return false;
            }
        }
        return true;
    };
    AppPagedTableComponent.prototype.isImgFromFb = function (img) {
        return this.commonService.isImgFromFb(img);
    };
    AppPagedTableComponent.prototype.scrollTop = function () {
        setTimeout(function () {
            window.scrollTo(0, 0);
        });
    };
    return AppPagedTableComponent;
}());
export { AppPagedTableComponent };
